import { Component, Input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IBetslipRootState } from '../../base/store/state';
import { betslipResultStateSelector } from '../../modules/result/selectors';
import { IBetslipResultState } from '../../modules/result/state';
import { BetslipTrackingLocation } from '../../modules/tracking/models';

@Component({
    selector: 'bs-digital-result-state',
    templateUrl: './betslip-result-state.component.html',
    styles: [
        `
            :host {
                display: block;
                height: 100%;
                overflow: auto;
            }
        `,
    ],
    standalone: false,
})
export class BetslipResultStateComponent {
    @Input() inColumn: boolean;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() isLinear = false;

    betslipResultTrackingLocation = BetslipTrackingLocation;
    betslipResultState$: Observable<IBetslipResultState>;

    constructor(store: Store<IBetslipRootState>) {
        this.betslipResultState$ = store.select(betslipResultStateSelector);
    }
}
